null


// WEBPACK FOOTER //
// ../../../../../../../../jducoeur/GitHub/jquery-facade/src/main/scala/org/querki/jquery/JQueryStatic.scala